import * as React from "react";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { Correction } from "../../../Request/DcfRequestReducer";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { LocalizedDateTime, DateTimeAccuracy } from '../../../../misc/components/LocalizedDateTime';

const PreviewSelector = (corrections: Correction[]): boolean => {
    return corrections.length > 0 && corrections[0].entity == "CoughSession" && corrections[0].field == "RecordingStartDateTime";
}

const RecordingStartPreviewItem = ({ corrections }: CorrectionItemPreviewProps): JSX.Element => {
    if (!(PreviewSelector(corrections))) {
        return null;
    }

    var from = <LocalizedDateTime time={corrections[0].oldValue} accuracy={DateTimeAccuracy.Second} isTooltip={true} />;
    var to = <LocalizedDateTime time={corrections[0].newValue} accuracy={DateTimeAccuracy.Second} isTooltip={true} />

    return <CorrectionBreakdownItem fieldName={corrections[0].field} from={from} to={to} />;
};

const RecordingStartPreview: CorrectionItemPreview = {
    previewElement: RecordingStartPreviewItem,
    previewSelector: PreviewSelector
};

export default RecordingStartPreview; 
